import React from "react"
import NutritionCalculatorWrapper from "./shared/nutritionCalculatorWrapper/NutritionCalculatorWrapper"
import NutritionCalculatorSearchInput from "./shared/nutritionCalculatorSearchInput/NutritionCalculatorSearchInput"
import NutritionCalculatorSearchResult from "./shared/nutritionCalculatorSearchResult/NutritionCalculatorSearchResult"
import NutritionCalculatorSelectedFood from "./shared/nutritionCalculatorSelectedFood/NutritionCalculatorSelectedFood"

const NutritionCalculator = ({
  searchedProduct,
  handleInput,
  handleSendSearchRequest,
  handleGetMeal,
  foodResults,
  selectedFood,
  handleClear,
  locale,
}) => {
  return (
    <NutritionCalculatorWrapper>
      <NutritionCalculatorSearchInput
        locale={locale}
        handleClear={handleClear}
        searchedProduct={searchedProduct}
        handleInput={handleInput}
        handleSendSearchRequest={handleSendSearchRequest}
      />
      {selectedFood && selectedFood ? (
        <NutritionCalculatorSelectedFood
          handleClear={handleClear}
          selectedFood={selectedFood}
        />
      ) : (
        <NutritionCalculatorSearchResult
          locale={locale}
          selectedFood={selectedFood}
          foodResults={foodResults}
          handleGetMeal={handleGetMeal}
        />
      )}
    </NutritionCalculatorWrapper>
  )
}

export default NutritionCalculator
